import React, { useEffect, useState } from "react";
import api, { formatApiError, asArray, fileUrl } from "../../lib/api";
import FileUpload from "./FileUpload";
import { Plus, Trash2, Edit3, X } from "lucide-react";
import { toast } from "sonner";

const inputCls = "w-full bg-transparent border-b border-black/15 focus:border-[#0060A7] outline-none py-2";

const blank = () => ({ name_ar: "", name_en: "", logo: "", category: "private", website: "", order: 0 });

export default function AdminClients() {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);

    const load = async () => { try { setItems(asArray((await api.get("/admin/clients")).data, "clients")); } catch (e) { toast.error(formatApiError(e)); } };
    useEffect(() => { load(); }, []);

    const save = async () => {
        try {
            const payload = { ...editing };
            payload.order = Number(payload.order) || 0;
            if (payload.id) await api.patch(`/admin/clients/${payload.id}`, payload);
            else await api.post("/admin/clients", payload);
            toast.success("Saved"); setEditing(null); load();
        } catch (e) { toast.error(formatApiError(e)); }
    };
    const remove = async (id) => {
        if (!window.confirm("Delete?")) return;
        try { await api.delete(`/admin/clients/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
    };

    if (editing) {
        const e = editing;
        return (
            <div data-testid="admin-client-form">
                <button onClick={() => setEditing(null)} className="text-sm text-[#6B7280] mb-6 inline-flex items-center gap-2"><X size={14} /> Cancel</button>
                <h2 className="heading text-3xl tracking-tight mb-8">{e.id ? "Edit Client" : "New Client"}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-8">
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Name (AR)</label><input className={inputCls} value={e.name_ar} onChange={(ev) => setEditing({ ...e, name_ar: ev.target.value })} /></div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Name (EN)</label><input className={inputCls} value={e.name_en} onChange={(ev) => setEditing({ ...e, name_en: ev.target.value })} /></div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Category</label>
                        <select className={inputCls} value={e.category} onChange={(ev) => setEditing({ ...e, category: ev.target.value })}>
                            <option value="ministry">Ministry</option>
                            <option value="authority">Authority</option>
                            <option value="holding">Holding</option>
                            <option value="private">Private</option>
                        </select>
                    </div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Order</label><input type="number" className={inputCls} value={e.order} onChange={(ev) => setEditing({ ...e, order: ev.target.value })} /></div>
                    <div className="md:col-span-2"><FileUpload value={e.logo} onChange={(v) => setEditing({ ...e, logo: v })} label="Logo" testid="client-logo-upload" /></div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Website</label><input className={inputCls} value={e.website} onChange={(ev) => setEditing({ ...e, website: ev.target.value })} /></div>
                </div>
                <div className="mt-6"><button onClick={save} className="bg-[#002951] hover:bg-[#0060A7] text-white px-8 py-3 text-sm uppercase tracking-[0.2em]">Save</button></div>
            </div>
        );
    }

    return (
        <div data-testid="admin-clients-page">
            <div className="flex items-center justify-between mb-6">
                <h1 className="heading text-3xl tracking-tight">Clients & Partners</h1>
                <button onClick={() => setEditing(blank())} className="bg-[#002951] hover:bg-[#0060A7] text-white px-5 py-2.5 text-sm inline-flex items-center gap-2"><Plus size={14} /> New</button>
            </div>
            <div className="bg-white">
                <table className="w-full text-sm">
                    <thead className="bg-[#EFF0F1] text-left text-xs uppercase tracking-[0.2em] text-[#6B7280]"><tr><th className="p-4">Logo</th><th className="p-4">Name</th><th className="p-4">Category</th><th className="p-4">Order</th><th className="p-4"></th></tr></thead>
                    <tbody>
                        {items.map((c) => (
                            <tr key={c.id} className="border-t border-black/5">
                                <td className="p-4">
                                    <div className="flex h-12 w-20 items-center justify-center bg-[#EFF0F1]">
                                        {c.logo ? (
                                            <img src={fileUrl(c.logo)} alt={c.name_en || c.name_ar} className="max-h-9 max-w-16 object-contain" />
                                        ) : (
                                            <span className="text-[10px] uppercase tracking-[0.2em] text-[#6B7280]">None</span>
                                        )}
                                    </div>
                                </td>
                                <td className="p-4"><div className="heading">{c.name_en}</div><div className="text-xs text-[#6B7280]">{c.name_ar}</div></td>
                                <td className="p-4 text-[#6B7280]">{c.category}</td>
                                <td className="p-4 text-[#6B7280]">{c.order}</td>
                                <td className="p-4 text-right">
                                    <button onClick={() => setEditing(c)} className="mr-3 text-[#0060A7]"><Edit3 size={16} /></button>
                                    <button onClick={() => remove(c.id)} className="text-red-500"><Trash2 size={16} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
